<template>
  <div class="sidebar sidebar-full d-none d-lg-block">
    <div
      class="custom-surveys-sidebar"
      :class="{
        'configurations-tab': isActiveTab(0),
        'survey-informations-tab': isActiveTab(1),
        'summary-tab': isActiveTab(2),
      }"
    >
      <div class="custom-surveys-sidebar-container" v-if="isActiveTab(0)">
        <div class="text-wrapper">
          <img src="/logos/logo_inline.svg" class="logo" />
          <br />
          <br />
          <h1 class="text-center">{{ labels.step_1.title }}</h1>
          <br />
          <p>{{ labels.step_1.desc_1 }}</p>
          <p>1&deg; {{ labels.step_1.desc_2 }}</p>
          <p>2&deg; {{ labels.step_1.desc_3 }}</p>
          <p>3&deg; {{ labels.step_1.desc_4 }}</p>
        </div>
        <div class="image-wrapper">
          <img :src="getImageUrl('configurations')" />
        </div>
      </div>
      <div class="custom-surveys-sidebar-container" v-if="isActiveTab(1)">
        <div class="text-wrapper">
          <img src="/logos/logo_inline.svg" class="logo" />
          <br />
          <br />
          <h1 class="text-center">{{ labels.step_2.title }}</h1>
          <br />
          <p>{{ labels.step_2.desc_1 }}</p>
          <p>{{ labels.step_2.desc_2 }}</p>
          <p>{{ labels.step_2.desc_3 }}</p>
          <p>{{ labels.step_2.desc_4 }}</p>
          <p>{{ labels.step_2.desc_5 }}</p>
        </div>
        <div class="image-wrapper">
          <img :src="getImageUrl('survey-informations')" />
        </div>
      </div>
      <div class="custom-surveys-sidebar-container" v-if="isActiveTab(2)">
        <div class="text-wrapper">
          <img src="/logos/logo_inline.svg" class="logo" />
          <br />
          <br />
          <h1 class="text-center">{{ labels.step_3.title }}</h1>
          <br />
          <p>{{ labels.step_3.desc_1 }}</p>
          <p>{{ labels.step_3.desc_2 }}</p>
          <p>{{ labels.step_3.desc_3 }}</p>
          <p>{{ labels.step_3.desc_4 }}</p>
          <p>{{ labels.step_3.desc_5 }}</p>
          <p>{{ labels.step_3.desc_6 }}</p>
          <p>Axel</p>
        </div>
        <div class="image-wrapper">
          <img :src="getImageUrl('summary')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  activeTab: {
    type: Number,
    default: 0,
  },
}

export default {
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.customSurveys.create.layout.sidebar
    },
  },
  methods: {
    getImageUrl(a) {
      return `https://static.teamculture.com.br/images/custom-surveys/${a}.svg`
    },
    isActiveTab(tab) {
      return this.activeTab === tab
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: relative;

  .custom-surveys-sidebar {
    padding: 30px 30px 0 30px;
    height: 100%;
    width: 360px;

    .custom-surveys-sidebar-container {
      min-height: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;

      .text-wrapper {
        flex-grow: 1;

        h1 {
          font-size: 1.3rem;
        }

        p {
          font-size: 0.9rem;
        }

        .logo {
          height: 35px;
          width: 220px;
        }
      }

      .image-wrapper {
        flex-shrink: 0;

        img {
          width: 100%;
        }
      }
    }

    &.configurations-tab {
      color: #d91c1c;
      background-color: #ffe8f0;
    }

    &.survey-informations-tab {
      color: #5f72aa;
      background-color: #88ccff;
    }

    &.summary-tab {
      color: #1f8107;
      background-color: #d6ffd4;
    }
  }
}
</style>
